<template>
    <div class="main page layout-column scroll">
	    <div class="header">
		    <h3>Integrations <span class="panel_head_amount">({{integrations.length}})</span></h3>
		    <!--						<a @click="newFunnelOpen=true" class="btn add_new_funnel_btn">Add a new funnel</a>-->
	    </div>

        <Loading v-if="loading"/>
          <div v-else class="funnel_apps_list">
              <router-link :to="'/integrations/'+item.id" class="funnel_app_item" v-for="(item, index) in integrations" :key="index">
                  <div class="left">
                      <div class="img_wrpr">
                          <img :src="'data:image/png;base64,'+item.small_image" alt="">
                      </div>
                      <div class="text_content">
                          <h3>{{item.caption}}</h3>
                          <p>{{item.description}}</p>
                      </div>
                  </div>
                  <label @click.stop class="switch_checkbox_item">
                      <input type="checkbox" :checked="itemActive(item.id)" @change="toggleActive($event, item.id)">
                      <div class="switch_checkbox"><span></span></div>
                  </label>
              </router-link>
        </div>

        <!-- IntegrationDetails -->
        <router-view @updated="updated"/>

    </div>
</template>

<script>
import {mapGetters} from "vuex"
import MainSearch from "@/components/MainSearch.vue"
import Loading from "@/components/Loading.vue"
import API from "@/api"

export default {
    name: "Integrations",
	title:"Integrations | Funnelish™",
    components: {
        MainSearch,
        Loading
    },
    mixins: [API],
    props: ['id'],
    data() {
        return {
            loading: true,
            searchInput: '',
            notifShow: true,
            integrations: [],
        }
    },
    methods: {
        updated(userIntegration) {
        	if (userIntegration) {
		        let int = this.integrations.find(item => {
			        return item.user_integration.id === userIntegration.id;
		        });//.attributes.active;

		        int.config = userIntegration.config;
	        }
        },
        itemActive(itemId){
            let i = this.integrations.find(item => {
                return item.id === itemId
            })
            return i.user_integration.active;
        },
        async toggleActive(event, itemId) {
            let patchedItem = this.integrations.find(item => {
                return item.id === itemId
            })

            patchedItem.user_integration.active = !patchedItem.user_integration.active;

            try {
                var result = await this.api.integrations.patchUserIntegration(patchedItem.id, patchedItem.user_integration);
            } catch (e) {
                this.$error(e)
            }
        },
        async init() {
        	try {
		        this.loading = true;
		        let response = await this.api.integrations.get(false, 'all');
		        this.integrations = response;
	        } catch (e) {
		        this.$error(e)
	        } finally {
		        this.loading = false;
	        }
        }
    },
    created() {
        this.init()
    }
}
</script>
